import React from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { centsToDollarString } from 'utils';

import { useUIContext } from 'state/ui';

export interface ICurrencyProps {
  isLoading?: boolean;
  amount?: number;
  prefix?: string;
  suffix?: string;
  hideCurrencySymbol?: boolean;
  id?: string;
  className?: any;
}

export const Currency = ({
  amount = 0,
  prefix = '',
  suffix = '',
  hideCurrencySymbol = false,
  className,
  isLoading,
}: ICurrencyProps) => {
  const { formatCurrencyForLocale } = useUIContext();
  const formattedAmount = hideCurrencySymbol
    ? centsToDollarString(amount)
    : formatCurrencyForLocale(amount);

  return (
    <SkeletonTheme color={Styles.color.grey.four}>
      <div aria-label={`${prefix}${formattedAmount}${suffix}`} className={className}>
        {isLoading ? (
          <Skeleton height="15px" width="40px" />
        ) : (
          <>
            {prefix}
            {formattedAmount}
            {suffix}
          </>
        )}
      </div>
    </SkeletonTheme>
  );
};

export default Currency;
